module.exports = __webpack_public_path__ + "static/media/sliderprev.ea882601.svg";